<div
    class="tw-font-[Figtree] tw-rounded-[10px] tw-p-[10px] tw-pb-[75px] tw-border tw-bg-[#C7EBFF3D] tw-border-[#6D7A873D] tw-relative md:tw-min-h-[535px] xl:tw-min-h-[460px] tw-max-w-[298px] tw-mx-auto"
>
    <div
        class="tw-flex tw-justify-center tw-mb-4 tw-min-h-[145px] tw-items-center tw-bg-white tw-mx-auto tw-rounded-[10px] tw-p-[15px]"
    >
        <img
            src="{{ product.img }}"
            alt="{{ product.productName }}"
            [ngClass]="
                product.orgCode === 'PSTR' ? 'tw-h-[80px]' : 'tw-h-[55px]'
            "
        />
    </div>
    <h2
        class="tw-text-center tw-text-[16px] tw-font-bold tw-text-[#000000] tw-mb-2"
    >
        {{ product?.productName }}
    </h2>

    <p
        class="!tw-text-[14px] !tw-font-normal tw-text-[#000000] tw-px-4 !tw-text-center"
    >
        {{
            selectedLanguage == "en"
                ? product?.productDescEng
                : product?.productDescBm
        }}
    </p>
    <button
        [attr.ga-event-id]="productSlug + '_apply_button_insurance_click'"
        ga-event-category="Insurance Page Button"
        ga-event-label="Apply Button Click"
        ga-track="track"
        (click)="applyProduct()"
        class="tw-w-full tw-text-[16px] tw-absolute tw-max-w-[90%] tw-left-[50%] tw-translate-x-[-50%] tw-bottom-[20px] tw-mx-auto tw-block tw-bg-[#4B6EEC] tw-cursor-pointer tw-transition-all tw-text-[#FFFAFA] tw-p-3 tw-rounded-full tw-font-semibold"
    >
        {{ "COMMON.APPLY" | translate }}
    </button>
</div>
